
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/experimental-api/classname-generator",
      function () {
        return require("private-next-pages/material-ui/experimental-api/classname-generator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/experimental-api/classname-generator"])
      });
    }
  